import swal from "sweetalert";
import useUser from "../../../../core/hooks/use-user";
import Datatable from "../../../../core/ui/components/Datatable";
import { sweetAl, toast } from "../../../../core/helpers/message-helper";
import { API_URL, BASE_PATH } from "../../../../core/config/env";
import FormPersonas from "../components/FormPersonas/form-personas";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import Swal from "sweetalert";
import {
    inactivarPersona,
    ingresarPersona,
    verPersona,
} from "../../services/personas-service";
import useModal from "../../../../core/hooks/use-modal";
import { useState } from "react";
import FormPermisos from "../components/form-permisos";
import FormUsuarios from "../components/form-usuarios";
import FormContratos from "../components/FormContratos/form-contratos";
import { SubAreasPersonaProvider } from "../../store/sub-areas-context";

const PersonasActivas = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState();

    const modalPersonas = useModal({
        title: "Editar Persona",
        data: { persona: {} },
    });

    const modalContratos = useModal({ data: { personaId: null } });

    const onSaved = () => {
        modalPersonas.set({ show: false });
        toast.success("Persona creada correctamente");
        dtInstance.ajax.reload();
    };

    const modalPermisos = useModal({
        title: "Administrar Permiso",
        data: { persona: {} },
    });

    const modalUsuario = useModal({
        title: "Crear usuario",
        data: { persona: {} },
    });

    const onSavedUser = () => {
        modalUsuario.set({ show: false });
        toast.success("Usuario creado correctamente");
        dtInstance.ajax.reload();
    };

    const getDtInstance = (dt) => onDtInstance(dt);

    let tableButtons = [];

    if (userCan("personasCrear")) {
        tableButtons.push({
            titleAttr: "Crear persona",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalPersonas.set({
                    show: true,
                    title: "Crear persona",
                    data: { persona: {} },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("personasEditar")) {
        tableButtons.push({
            titleAttr: "Editar persona",
            text: '<i class="fas fa-pen"></i>',
            action: async function (e, dt) {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const resp = await verPersona(data.id);

                const persona = {
                    ...resp.data,
                    sedes_areas: resp.data.sedes_areas,
                };

                modalPersonas.set({
                    show: true,
                    title: "Editar Persona",
                    data: { persona },
                });
            },
            className: "btn btn-sm btn-primary",
        });
    }

    if (userCan("personasInactivar")) {
        tableButtons.push({
            titleAttr: "Inactivar persona",
            text: '<i class="fas fa-trash"></i>',
            className: "btn btn-sm btn-danger",
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea inactivar esta persona?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        inactivar: {
                            text: "Inactivar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se a inactivado la persona");
                        break;
                    case "inactivar": {
                        const resp = await inactivarPersona(data.id);

                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al inactivar la persona"
                            );
                        }

                        sweetAl.success(
                            "La persona fue inactivada correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
        });
    }

    if (userCan("personaCrearUsuario")) {
        tableButtons.push({
            titleAttr: "Crear usuarios",
            text: '<i class="fas fa-user"></i>',
            action: async function (e, dt) {
                const data = dt.row({ selected: true }).data();
                if (!data) return;
                modalUsuario.set({
                    show: true,
                    title: "Crear usuario",
                    data,
                });
            },
            className: "btn btn-sm btn-salmon",
        });
    }

    if (userCan("personasAdministrarPermisos")) {
        tableButtons.push({
            titleAttr: "Administrar permisos",
            text: '<i class="fas fa-list"></i>',
            action: async function (e, dt) {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const resp = await verPersona(data.id);

                modalPermisos.set({
                    show: true,
                    title: "Administrar Permisos",
                    data: { persona: resp.data },
                });
            },
            className: "btn btn-sm btn-grey",
        });
    }

    if (userCan("personaCrearContrato")) {
        tableButtons.push({
            titleAttr: "Crear Contrato",
            text: '<i class="fas fa-file-signature"></i>',
            action: async function (e, dt) {
                const data = dt.row({ selected: true }).data();
                if (!data) return;
                modalContratos.set({
                    show: true,
                    data: { personaId: data.id },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("personaIngresarPersona")) {
        tableButtons.push({
            titleAttr: "Login",
            text: '<i class="fas fa-sign-in-alt"></i>',
            action: async function (e, dt) {
                const data = dt.row({ selected: true }).data();
                if (!data || !data.usuario) return;

                const confirmacion = await sweetAl.confirm(
                    "¿Deseas ingresar con este usuario?"
                );
                if (!confirmacion) return;

                const response = await ingresarPersona(data.usuario);

                if (response.status) {
                    const token = response.data.accessToken;

                    Swal({
                        title: "Logueando Usuario...",
                        timer: 3000,
                    }).then(() => {
                        window.localStorage.setItem("accessToken", token);
                        window.location.href = (BASE_PATH === '/' ? '' : BASE_PATH) + "/dashboard";
                    });
                } else {
                    toast.error(response.message);
                }
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "Personas-activas",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaActivas",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/personas/activas`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listdo de las personas"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "info_documento" },
            { data: "info_persona" },
            { data: "fecha_nace" },
            { data: "area" },
            { data: "usuario" },
            { data: "email_persona" },
            { data: "estado_persona" },
        ],
        columnDefs: [
            {
                targets: [7],
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>USUARIOS / Activos</div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table className="w-100 table table-hover" id="tablaActivas">
                    <thead className="bg-dark">
                        <tr>
                            <th className="text-center text-white">Id</th>
                            <th className="text-center text-white">
                                Documento
                            </th>
                            <th className="text-center text-white">Nombre</th>
                            <th className="text-center text-white">
                                Fecha de nacimiento
                            </th>
                            <th className="text-center text-white">Area</th>
                            <th className="text-center text-white">Usuario</th>
                            <th className="text-center text-white">Correo</th>
                            <th className="text-center text-white">Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>

            <SubAreasPersonaProvider>
                <FormPersonas modalState={modalPersonas} onSaved={onSaved} />
            </SubAreasPersonaProvider>
            <FormUsuarios modalState={modalUsuario} onSaved={onSavedUser} />
            <FormPermisos modalState={modalPermisos} />
            <FormContratos modalState={modalContratos} />
        </ContentWrapper>
    );
};

export default PersonasActivas;
